import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

export default function ChevronDown({className, ...props}) {
  return (
    <div className={cx('icon', className)} {...props}>
      <svg width={'14px'} height={'8px'} viewBox={'0 0 14 8'}>
        <g
          stroke={'none'}
          strokeWidth={'1'}
          className={'icon__fill'}
          fillRule={'evenodd'}
        >
          <g transform={'translate(-5.000000, -8.000000)'} fillRule={'nonzero'}>
            <path
              d={
                'M17.2928932,8.29289322 C17.6834175,7.90236893 18.3165825,7.90236893 18.7071068,8.29289322 C19.0976311,8.68341751 19.0976311,9.31658249 18.7071068,9.70710678 L12.7071068,15.7071068 C12.3165825,16.0976311 11.6834175,16.0976311 11.2928932,15.7071068 L5.29289322,9.70710678 C4.90236893,9.31658249 4.90236893,8.68341751 5.29289322,8.29289322 C5.68341751,7.90236893 6.31658249,7.90236893 6.70710678,8.29289322 L12,13.5857864 L17.2928932,8.29289322 Z'
              }
            ></path>
          </g>
        </g>
      </svg>
    </div>
  )
}

ChevronDown.propTypes = {
  className: PropTypes.string,
}
